<template>
  <!-- Content Wrapper. Contains page content -->

  <div>
    <div
      :style="{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        paddingRight: '2px',
        paddingLeft: '2px',
        color: corTexto,
      }"
      class="app"
    >
      <br />

      <button
        :style="{
          alignItems: 'center',
          marginTop: '5px',
          marginBottom: '5px',
          backgroundColor: corBotao,
          color: corTexto,
        }"
        class="btn"
      >
        Sou cadastrado
      </button>
      <form >
        <div class="form-group" v-if="tipoLogin=='0' || tipoLogin=='1'">
          <label for="exampleInputEmail1">Endereço de email</label>
          <input
            type="email"
            v-model="email"
            class="form-control"
            id="email"
            aria-describedby="emailHelp"
            placeholder="Seu email"
          />
        </div>
        <span v-if="tipoLogin=='0'">
          <div class="form-group">
            <label for="exampleInputPassword1">Senha</label>
            <input
              type="password"
              v-model="senha"
              class="form-control"
              id="senha"
              placeholder="Senha"
            />
          </div>
        </span>
        <span v-if="tipoLogin=='3'">
            <div class="form-group">
          <label for="exampleInputEmail1">Número de telefone</label>
          <input
            type="tel"
            v-model="telefone"
            class="form-control"
            id="telefone"
            aria-describedby="telefoneHelp"
            placeholder="Seu número"
          />
        </div>
        </span>
        <div style="display: flex; flex-direction:column;">
          <div>
            <button
              style="background-color: #006400"
              type="submit"
              class="btn btn-dark"
              @click.prevent="logar()"
            >
              Entrar
            </button>
          </div>
          <span v-if="tipoLogin == 0">
            <div>
              <button
                style="margin-top: 5px; background-color: #006400"
                type="submit"
                class="btn btn-dark"
                @click.prevent="pushEsqueciSenha()"
              >
                Esqueci minha senha
              </button>
            </div>
          </span>
          <div>
            <button
              style="
              align-items: center;
              margin-top: 5px;
              margin-bottom: 5px;
              background-color: #006400; ;
            "
              class="btn btn-dark"
              @click.prevent="pushCadastro()"
            >
              Cadastre-se
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<style>
.botao {
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>
<script>
import Usuario from "../services/usuario";
import Swal from "sweetalert2";
import Inis from "../services/inis";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      senha: "",
      telefone: "",
      corBotao: "",
      corTexto: "",
      corFundo: "",
      tipoLogin: "",
      usuario: {},
      logadoAux: false,
    };
  },
  computed: {
    logado: {
      get() {
        return this.$store.state.logado;
      },
    },
  },
  methods: {
    pushCadastro() {
      this.$router.push("/cadastro");
    },
    async pushEsqueciSenha() {
      /*
      if (email == "") {
        Swal.fire({
          title: "Preencha um email válido",
          confirmButtonColor: "#000000",
        });
      } else if (re.test(String(email).toLowerCase()) == false) {
        Swal.fire({
          title: "Preencha um email válido",
          confirmButtonColor: "#000000",
        });
      } else {
        await Usuario.listandotelefone(email).then(resposta => {
          this.telefone = resposta.data;
        });
        if (this.telefone == null) {
          Swal.fire({
            title: "Email inexistente",
            confirmButtonColor: "#000000",
          });
        } else {
          localStorage.setItem(
            "email" + localStorage.getItem("contrato"),
            email
          );
          this.$store.commit("setTelefone", this.telefone[0].fone);
          
          this.$router.push("/esquecisenha");
        }
      }
      */
      this.$router.push("/esquecisenha");
    },
    routerWhats() {
      this.$router.push("/finalizado");
    },
    listandoInis() {
      var cd = "TIPO_LOGIN";
      Inis.listarInisCd(cd).then(resposta => {
        this.tipoLogin = resposta.data[0].vl;
      });
      var cd = "Cor_primaria";
      Inis.listarInisCd(cd).then(resposta => {
        this.corFundo = resposta.data[0].vl;
      });
      var cd = "Cor_secundaria";
      Inis.listarInisCd(cd).then(resposta => {
        this.corBotao = resposta.data[0].vl;
      });
      var cd = "Cor_tercearia";
      Inis.listarInisCd(cd).then(resposta => {
        this.corTexto = resposta.data[0].vl;
      });
      var cd = "ID_PIXEL";
      Inis.listarInisCd(cd).then(response => {
        this.idPixel = response.data[0].vl;
      });
    },
    loadFacebookPixel(idPixel, type) {
      // Crie o elemento <script> para carregar o Pixel
      var script = document.createElement("script");
      script.src = "https://connect.facebook.net/en_US/fbevents.js";
      script.async = true;

      // Adicione o Pixel ID à chamada de inicialização do Pixel
      var initCode = 'fbq("init", "' + idPixel + '");';

      // Crie o elemento <noscript> para o caso de o usuário não ter JavaScript habilitado
      var noscript = document.createElement("noscript");
      var img = document.createElement("img");
      img.height = 1;
      img.width = 1;
      img.style.display = "none";
      img.src =
        "https://www.facebook.com/tr?id=" + idPixel + `&ev=${type}&noscript=1`;

      // Adicione o código de inicialização ao elemento <noscript>
      noscript.appendChild(document.createTextNode(initCode));
      noscript.appendChild(img);

      // Adicione os elementos ao DOM
      document.head.appendChild(script);
      document.head.appendChild(noscript);
    },
    logar() {
      if (this.tipoLogin == 1) {
        if (this.email == "") {
          Swal.fire({
            title: "Porfavor, digite o email",
            confirmButtonColor: "#000000",
          });
        } else {
          Usuario.listandoLogin(this.email,null,null).then(resposta => {
            if (resposta.data == null) {
              Swal.fire({
                title: "Email inválido",
                confirmButtonColor: "#000000",
              });
            } else {
              if (this.idPixel != "") {
                this.loadFacebookPixel(this.idPixel, "CompleteRegistration");
              }
              this.usuario = resposta.data[0];
                localStorage.setItem(
                  "email" + localStorage.getItem("contrato"),
                  this.email
                );
                localStorage.setItem(
                  "nm" + localStorage.getItem("contrato"),
                  this.usuario.nm
                );
                localStorage.setItem(
                  "cd" + localStorage.getItem("contrato"),
                  this.usuario.cd
                );

                this.$store.commit("setNome", this.usuario.nm);
                this.$store.commit("setLogado", true);

                this.$router.push("/finalizadoLogin");
              
            }
          });
        }
      } else if (this.tipoLogin == 3) {
        if (this.telefone == "") {
          Swal.fire({
            title: "Porfavor, digite o telefone",
            confirmButtonColor: "#000000",
          });
        } else {
          Usuario.listandoLogin(null,null,this.telefone).then(resposta => {
            console.log(resposta.data);
            if (resposta.data == null) {
              Swal.fire({
                title: "Telefone inválido",
                confirmButtonColor: "#000000",
              });
            } else {
              if (this.idPixel != "") {
                this.loadFacebookPixel(this.idPixel, "CompleteRegistration");
              }
              this.usuario = resposta.data[0];

                localStorage.setItem(
                  "tipoCadastro" + localStorage.getItem("contrato"),
                  this.tipoLogin
                );
                localStorage.setItem(
                  "nm" + localStorage.getItem("contrato"),
                  this.usuario.nm
                );
                localStorage.setItem(
                  "cd" + localStorage.getItem("contrato"),
                  this.usuario.cd
                );
                  console.log(this.usuario.cd)
                localStorage.setItem(
                  "telefone" + localStorage.getItem("contrato"),
                  this.telefone
                );

                this.$store.commit("setNome", this.usuario.nm);
                this.$store.commit("setLogado", true);

                this.$router.push("/finalizadoLogin");
              
            }
          });
        }
      } else if (this.tipoLogin == 0) {
        if (this.email == "") {
          Swal.fire({
            title: "Porfavor, digite o email",
            confirmButtonColor: "#000000",
          });
        } else if (this.senha == "") {
          Swal.fire({
            title: "Porfavor, digite a senha",
            confirmButtonColor: "#000000",
          });
        } else {
          Usuario.listandoLogin(this.email,this.senha,null).then(resposta => {
            if (resposta.data == null) {
              Swal.fire({
                title: "Email ou Senha inválido",
                confirmButtonColor: "#000000",
              });
            } else {
              if (this.idPixel != "") {
                this.loadFacebookPixel(this.idPixel, "CompleteRegistration");
              }
              this.usuario = resposta.data[0];
                localStorage.setItem(
                  "email" + localStorage.getItem("contrato"),
                  this.email
                );
                localStorage.setItem(
                  "nm" + localStorage.getItem("contrato"),
                  this.usuario.nm
                );
                localStorage.setItem(
                  "cd" + localStorage.getItem("contrato"),
                  this.usuario.cd
                );

                this.$store.commit("setNome", this.usuario.nm);
                this.$store.commit("setLogado", true);

                this.$router.push("/finalizadoLogin");
              
            }
          });
        }
      }
    },
  },
  mounted() {
    this.listandoInis();
  },
};
</script>
